// Orders line chart — shows orders per day over the last 30 days.
// Extracted from Reports.tsx during Maintainability Sprint 2026-04-19
// (Task 1.2 step 1). See docs/superpowers/plans/.
import { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useRevenue } from "@/hooks/admin/useFinance";
import { formatShortDate } from "./formatters";
import ChartTooltip from "./ChartTooltip";

export default function OrdersLineChart() {
  const now = new Date();
  const dateTo = now.toISOString().split("T")[0];
  const dateFromObj = new Date(now);
  dateFromObj.setDate(dateFromObj.getDate() - 30);
  const dateFrom = dateFromObj.toISOString().split("T")[0];

  const { data, isLoading } = useRevenue("day", dateFrom, dateTo);
  const series = data?.series ?? [];

  const chartData = useMemo(
    () =>
      series.map((point) => ({
        ...point,
        label: formatShortDate(point.date),
      })),
    [series],
  );

  if (isLoading) {
    return (
      <div className="rounded-lg border border-stone-200 bg-white p-5">
        <div className="h-4 w-40 animate-pulse rounded bg-stone-100" />
        <div className="mt-4 flex h-48 items-center justify-center">
          <div className="h-6 w-6 animate-spin rounded-full border-2 border-amber-600 border-t-transparent" />
        </div>
      </div>
    );
  }

  if (chartData.length === 0) return null;

  return (
    <div className="rounded-lg border border-stone-200 bg-white p-5">
      <h3 className="mb-4 text-sm font-semibold text-stone-900">
        Commandes par jour (30 derniers jours)
      </h3>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={chartData} margin={{ top: 5, right: 10, left: 10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e7e5e4" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#78716c" }}
            tickLine={false}
            axisLine={{ stroke: "#d6d3d1" }}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#78716c" }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip content={<ChartTooltip />} />
          <Line
            type="monotone"
            dataKey="orders"
            stroke="#D4A535"
            strokeWidth={2}
            dot={{ r: 3, fill: "#D4A535" }}
            activeDot={{ r: 5 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
